const GATSBY_ENV = process.env.GATSBY_ENV

const baseUrl =
  process.env.GATSBY_ENV === "staging"
    ? "https://cloud.stage.api.trimblecloud.com/cloud/trials-service/1.0/"
    : process.env.GATSBY_ENV === "production"
    ? "https://cloud.api.trimble.com/cloud/trials-service/1.0/"
    : "https://cloud.api.trimble.com/cloud/trials-service/1.0/"

export const getTrialFormId = timeStamp => {
  if (timeStamp) {
    // the token for all requests is only valid for 60 minutes after the initial authentication of a user. This checks if the token has expired
    const diff = (Date.now() - timeStamp) / 60000
    if (diff > 60) {
      return false
    } else {
      return true
    }
  }
}

export const checkForHealth = (
  setLoading,
  setError,
  setCheckHealthOfTrialsAPI,
  setErrorText,
  setAuth
) => {
  const myHeaders = new Headers()

  myHeaders.append("path", "/oauth/token")
  myHeaders.append("hostname", "https://stage.id.trimblecloud.com")
  myHeaders.append("content-type", "application/x-www-form-urlencoded")
  myHeaders.append(
    "Authorization",
    `Bearer ${JSON?.parse(localStorage.getItem("user-trial-data"))?.id}`
  )

  myHeaders.append("Access-Control-Allow-Origin", "*")
  myHeaders.append(
    "Access-Control-Allow-Methods",
    "Content-Type",
    "Authorization"
  )

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  }

  setLoading(true)

  fetch(`${baseUrl}trials/health`, requestOptions)
    .then(response => response.status)
    .then(result => {
      console.log(result)
      if (result === 401) {
        setAuth(false)
        setLoading(false)
      }
      setCheckHealthOfTrialsAPI(true)
    })
    .catch(error => {
      console.log(error)
      setError(true)
      setErrorText(error)
      setLoading(false)
    })
}

export const startTrial = (
  setLoading,
  setError,
  setErrorText,
  sku,
  days = 30
) => {
  setLoading(true)
  fetch(`${baseUrl}trials/initialize`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        JSON.parse(localStorage.getItem("user-trial-data"))?.id
      }`,
    },
    body: JSON.stringify({
      sku: `${sku}`,
      periodInDays: days,
    }),
  })
    .then(response => response.json())
    .then(result => {
      if (result?.errorMessage) {
        setErrorText(result)
        setError(true)
        setLoading(false)
      } else {
        setTimeout(() => {
          window.location.reload(true)
        }, 3000)
      }
    })
    .catch(error => {
      console.log(error)
      setError(true)
      setErrorText(error)
      setLoading(false)
    })
}

export const getTrialDetails = (sku, setActiveTrial, setLoading, setError) => {
  setLoading(true)

  fetch(`${baseUrl}trials/licenses?sku=${sku}`, {
    headers: {
      Authorization: `Bearer ${
        JSON.parse(localStorage.getItem("user-trial-data"))?.id
      }`,
    },
  })
    .then(response => response.json())
    .then(result => {
      console.log(result)
      // this should return an empty array if there is not a trial
      if (result && result?.licenses?.length) {
        setActiveTrial(result?.licenses)
      }
      setLoading(false)
    })
    .catch(error => {
      console.log(error)
      setActiveTrial(false)
    })
}

async function sendToWorkato(data) {
  const workatoProxy = "/.netlify/functions/workato-webhook"

  try {
    const response = await fetch(workatoProxy, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    const responseData = await response.json()
  } catch (error) {
    console.error("Error sending data to Workato:", error)
  }
}

const submitToWorkato = async formDetails => {
  const userdata = JSON.parse(localStorage.getItem("user_info"))
  console.log(userdata)
  const workatoData = {
    "Event_Name": "ts_profileCreate",
    Timestamp: new Date().toISOString(), // ISO 8061 'YYYY-MM-DDTHH:mm:ss.sssZ'
    "Trimble_Id_UUID": userdata?.tid,
    "First_Name": userdata?.fName,
    "Last_Name": userdata?.lName,
    Email: userdata?.email,
    "Device_IP_Address": "",
    "Device_Country": formDetails?.CountryCode,
    "Phone_Number": "",
    Country: formDetails?.CountryCode,
    Region: formDetails?.StateCode,
    Locality: "",
    "Marketing_Consent": formDetails?.expressOptInSubmitted == "yes" ? true : "",
    "Time_Zone": "",
    Language: "",
    "Industry (if known)": "",
    "Company Name (if known)": "",
    "Company Size (if known)": "",
    "Job Role (if known)": "",
    "SKU": formDetails?.TNV_Recent_Software_Trial_SKU__c,
  }
  sendToWorkato(workatoData)
}

export { submitToWorkato }
